import { render, staticRenderFns } from "./EduServicesPage.vue?vue&type=template&id=2f0c2a99&scoped=true"
import script from "./EduServicesPage.vue?vue&type=script&lang=js"
export * from "./EduServicesPage.vue?vue&type=script&lang=js"
import style0 from "./EduServicesPage.vue?vue&type=style&index=0&id=2f0c2a99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0c2a99",
  null
  
)

export default component.exports